'use client';

import {
  VtmnModal,
  VtmnModalActions,
  VtmnModalDescription,
  VtmnModalTitle,
} from '@vtmn/react';
import { useTranslations } from 'next-intl';
import { CustomSwipeableDrawer } from '~/components/commons/CustomSwipeableDrawer/CustomSwipeableDrawer';
import { Portal } from '~/components/commons/Portal/Portal';
import { useBreakpoint } from '~/hooks/match-media/useBreakpoint';
import { GuestModeAction } from './GuestModeActions';
import { GuestModeDescription } from './GuestModeDescription';

export const GuestModeAccess = ({
  isOpen,
  route,
  handleClose,
  handleOpen,
  onAccessAsGuest,
}: {
  isOpen: boolean;
  route: string;
  handleClose: () => void;
  handleOpen: () => void;
  onAccessAsGuest: () => void;
}) => {
  const t = useTranslations('GUEST_MODAL');

  const { isSBreakpoint } = useBreakpoint();

  return (
    <Portal>
      {isSBreakpoint
        ? (
            <CustomSwipeableDrawer
              dataTestId="guest-mode-drawer"
              open={isOpen}
              title={t('TITLE')}
              onClose={handleClose}
              onOpen={handleOpen}
            >
              <div className="guest-mode-access">
                <p className="vtmn-modal_content_body--text">
                  <GuestModeDescription />
                </p>
                <div className="guest-mode-access__actions">
                  <GuestModeAction
                    route={route}
                    onAccessAsGuest={onAccessAsGuest}
                  />
                </div>
              </div>
            </CustomSwipeableDrawer>
          )
        : (
            <VtmnModal
              data-testid="guest-mode-modal"
              className="guest-mode-access"
              open={isOpen}
              onClose={handleClose}
            >
              <VtmnModalTitle>{t('TITLE')}</VtmnModalTitle>
              <VtmnModalDescription>
                <GuestModeDescription />
              </VtmnModalDescription>
              <VtmnModalActions>
                <GuestModeAction
                  route={route}
                  onAccessAsGuest={onAccessAsGuest}
                />
              </VtmnModalActions>
            </VtmnModal>
          )}
    </Portal>
  );
};
